module.exports = __webpack_public_path__ + "static/media/avatar-personnel.f8399445.svg";